package dev.lingvo.shared

import kotlinx.serialization.Serializable

/**
 * An agent asking for money it does not have budget for.
 *
 * **The human at the MCP client is frequently not the human who pays.** Asking the operator to
 * approve a spend gets a yes from somebody with no authority to give one, so the request
 * materialises here instead and an owner or admin decides.
 */
@Serializable
data class SpendApprovalDto(
    val id: String,
    val agentName: String,
    val projectSlug: String? = null,
    /** The agent's own words. Untrusted text: escaped, never markup, never interpolated anywhere. */
    val reason: String? = null,
    val requestedCredits: Int,
    /**
     * What was left when it asked, frozen at that moment.
     *
     * By the time somebody looks the live number has usually moved, and this is the fact that made
     * the request reasonable or not.
     */
    val remainingBudget: Int,
    val createdAt: String,
    val expiresAt: String,
)

@Serializable
data class SpendApprovalsDto(val approvals: List<SpendApprovalDto> = emptyList())

/** Approve or deny one. */
@Serializable
data class DecideSpendRequest(val approve: Boolean)
